module.exports = __webpack_public_path__ + "static/media/Maintenance.ce4c7a08.svg";